import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'
import ComitObj from '../pages/ComitObj.vue'
import ComAbout from '../pages/ComAbout.vue'
import ComCulture from '../pages/ComCulture.vue'
import News from '../pages/News.vue'
import Synopsis from '../components/Synopsis.vue'
import Honor from '../components/Honor.vue'
import Partner from '../components/Partner.vue'
import Connection from '../components/Connection.vue'
import Care from '../components/Care.vue'
import Activity from '../components/Activity.vue'
import Grow from '../components/Grow.vue'
import Joinus from '../components/Joinus.vue'
import Traffic from '../components/Traffic.vue'
import YouJia from '../components/YouJia.vue'
import Change from '../components/Change.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    mode:'hash',
    routes:[{
        path:'/home',
        name:'home',
        component:Home,
    },{
        path:'/comobject',
        component:ComitObj,
        children:[{
            path:'traffic',
            component:Traffic
        },{
            path:'youjia',
            component:YouJia
        },{
            path:'change',
            component:Change
        },{
            path:'/',
            redirect:'traffic'
        }]
    },{
        path:'/comabout',
        component:ComAbout,
        children:[{
            path:'synopsis',
            component:Synopsis
        },{
            path:'honor',
            component:Honor
        },{
            path:'partner',
            component:Partner
        },{
            path:'connection',
            component:Connection
        },{
            path:'/',
            redirect:'synopsis'
        }]
    },{
        path:'/comculture',
        component:ComCulture,
        children:[{
            path:'care',
            component:Care
        },{
            path:'activity',
            component:Activity
        },{
            path:'grow',
            component:Grow
        },{
            path:'joinus',
            component:Joinus
        },{
            path:'/',
            redirect:'care'
        }]
    },{
        path:'/news',
        component:News
    },{
        path:'/',
        redirect:'/home',
    }]
})

export default router